import { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../../app/hooks";
import useLocales from "../../../hooks/useLocales";
import FilterListIcon from "@mui/icons-material/FilterList";
import NewCreateButton from "../../buttons/NewCreateButton";
import { selectTheme } from "../../../features/theme/ThemeSlice";
import SearchIcon from "@mui/icons-material/Search";
import LeftIcon from "@mui/icons-material/ChevronLeft";
import ClearIcon from "@mui/icons-material/Clear";
import RightIcon from "@mui/icons-material/ChevronRight";
import { Button, Grid, TextField, IconButton } from "@mui/material";
import {
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";

export const defaultToolbar = {
  create: true,
  export: false,
  dense: true,
  columnVisibility: true,
  filter: true,
  advancedFilter: false,
  customFilter: false,
  search: false,
  excel: false,
};

const Toolbar: FC<any> = (props) => {
  const { translate } = useLocales();
  const { pathname } = useLocation();
  const [filterOpen, setFilterOpen] = useState<boolean>(
    props.hideToolbars?.defaultOpenFilter
  );
  const dark = useAppSelector(selectTheme);
  const [show, setShow] = useState<boolean>(
    props.hideToolbars?.defaultOpenFilter
  );

  function showButtonHandler() {
    setShow((prev: boolean) => !prev);
  }

  useEffect(() => {
    if (!show) setFilterOpen(false);
  }, [show]);

  const searchStyle = {
    minHeight: "44px",
    "& .MuiOutlinedInput-root": {
      minHeight: "44px",
      paddingLeft: "20px",
    },
    "& svg": {
      color: dark === true ? "#FFF" : "rgba(0, 0, 0, 0.38)",
      marginLeft: "-10px",
      marginRight: "11px",
    },
  };

  const hiddenButtons = (
    <>
      {props.hideToolbars?.customFilter && (
        <>{props.customFilter && <Grid item>{props.customFilter}</Grid>}</>
      )}
      {props.hideToolbars?.advancedFilter && (
        <>{props.advancedFilter && <Grid item>{props.advancedFilter}</Grid>}</>
      )}

      {props.hideToolbars?.filter && (
        <>
          {props.filters ? (
            <Grid item>
              <Button
                sx={styleButton}
                startIcon={<FilterListIcon />}
                variant="outlined"
                onClick={() => setFilterOpen((prev) => !prev)}
              >
                {translate("actions.filter")}
              </Button>
            </Grid>
          ) : (
            <Grid item>
              <GridToolbarFilterButton
                sx={styleButton}
                ref={props.setFilterButtonEl}
              />
            </Grid>
          )}
        </>
      )}
      {props.hideToolbars?.columnVisibility && (
        <Grid item>
          <GridToolbarColumnsButton
            sx={styleButton}
            ref={props.setColumnButtonEl}
          />
        </Grid>
      )}

      {props.hideToolbars?.dense && (
        <Grid item>
          <GridToolbarDensitySelector sx={styleButton} />
        </Grid>
      )}
      {props.hideToolbars?.export && (
        <>
          {props?.customExport ? (
            <Grid item>{props.customExport}</Grid>
          ) : (
            <Grid item>
              <GridToolbarExport />
            </Grid>
          )}
        </>
      )}
    </>
  );
  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        spacing={2}
        sx={{ marginBottom: "30px" }}
      >
        {props.hideToolbars?.search && (
          <Grid item>
            <TextField
              sx={searchStyle}
              variant="outlined"
              value={props.value}
              onChange={props.onChange}
              placeholder={translate("actions.search")}
              fullWidth
              style={{ maxHeight: "40px" }}
              InputProps={{
                startAdornment: <SearchIcon fontSize="small" />,
                endAdornment: (
                  <IconButton
                    title="Clear"
                    aria-label="Clear"
                    size="small"
                    style={{ visibility: props.value ? "visible" : "hidden" }}
                    onClick={props.clearSearch}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />
          </Grid>
        )}
        {props.excelButtons}
        {props.supplierButton}
        {props.hideToolbars?.showActions && (
          <Grid item>
            <Button
              sx={styleButton}
              startIcon={!show && <LeftIcon />}
              endIcon={show && <RightIcon />}
              variant="outlined"
              onClick={showButtonHandler}
            >
              {translate("actions.root")}
            </Button>
          </Grid>
        )}

        {show && hiddenButtons}
        {props.hideToolbars?.create && (
          <Grid item>
            <NewCreateButton
              path={props.path}
              pathname={pathname}
              onClick={props.createBtnClickHandler}
            />
          </Grid>
        )}
      </Grid>

      {filterOpen && props.filters}
      {/* Additional Custom Toolbar */}
      {props?.enchancedToolbar && props.enchancedToolbar}
    </>
  );
};

const styleButton = {
  boxShadow: "none",
  fontSize: 16,
  padding: "6px 12px",
  color: "#999999",
  border: "1px solid #D9D9D9",
  lineHeight: 1.5,
  position: "relative",
  height: "46px",
  fontWeight: "400",
  textDecoration: "none",
  textTransform: "none",
  "& span": {
    textDecoration: "none",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
  "&:hover": {
    background: "none",
    color: "#853EF8",
    "& svg": {
      color: "#853EF8",
    },
  },
};

export default Toolbar;
